import { createRoot } from "react-dom/client";
import { PasswortNeuAnsicht } from "./formulare/konto.jsx";
import { OeffentlicheAnsicht } from "./oeffentlich.jsx";
import { WineLake } from "./shell.jsx";

/* ================================================================
   WineLake · Kellerbuch & Jahrgangsarchiv — Einstiegspunkt
   ----------------------------------------------------------------
   Web-Ausgabe für den eigenen Server (Node/Express, Dateispeicher).
   Sync-Konzept: Der komplette Kellerbuch-Stand liegt als versioniertes
   JSON-Dokument auf dem Server. Der Client hält eine lokale Kopie
   (localStorage) und fragt beim Start nur die Versionsnummer ab —
   geladen wird ausschließlich bei einem tatsächlichen Update.
   Schreiben erfolgt mit optimistischer Sperre (409 bei Konflikt).

   Modulaufbau (Import-Richtung strikt von oben nach unten):
     kern/        Konstanten, Formatierung, Fachlogik, Kellerbuch-API
     dienste/     Witterung (Open-Meteo), Etikettenfotos, Excel-Impex,
                  Weltkarte (TopoJSON)
     ui/          Primitive (Btn, Modal, SuchAuswahl, …) und Hooks
     formulare/   Stammdaten-, Jahrgangs- und Verwaltungsformulare
     ansichten/   Eine Datei je Seite (Keller, Weine, Jahrgang, …)
     shell.jsx    App-Rahmen: Routing, Modals, Synchronisation
     stil.js      Design-Line „Kellerbuch" (globales Stylesheet)
   Tests: node tests/lauf.js (nach npm install)
   ================================================================ */

/* Öffentliche, schreibgeschützte Freigaben laufen ohne Anmeldung
   und ohne den App-Rahmen: /geteilt/<token>. Alles andere ist die
   normale, angemeldete Anwendung. */
const geteilt = window.location.pathname.match(/^\/geteilt\/([A-Za-z0-9_-]+)\/?$/);
/* Ebenfalls ohne Anmeldung: der Link aus der „Passwort vergessen“-Mail. */
const passwortNeu = window.location.pathname.match(/^\/passwort-neu\/([A-Za-z0-9_-]+)\/?$/);

/* Dienst-Arbeiter anmelden (siehe public/sw.js). Er hält die
   Anwendungsschale vor, damit die App ohne Netz überhaupt startet;
   der Kellerbuchstand selbst kommt weiterhin aus dem localStorage.
   Erst nach `load`, damit die Registrierung den ersten Aufbau nicht
   verzögert. Schlägt sie fehl (privater Modus, unsicherer Kontext),
   läuft alles wie zuvor — nur eben nur mit Netz. */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

createRoot(document.getElementById("root")).render(
  geteilt ? <OeffentlicheAnsicht token={geteilt[1]} />
    : passwortNeu ? <PasswortNeuAnsicht token={passwortNeu[1]} />
      : <WineLake />
);
